import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';

import { Row, Stack } from '@raptormaps/layout';
import { Text } from '@raptormaps/text';

import { getSolarFarmByUuidQuery } from '../../api/services/solar-farm';
import { useSearchParams } from '../../hooks/useSearchParams';
import { SolarFarmTypeahead } from './SolarFarmTypeahead';

export const FarmPermissions = () => {
  const history = useHistory();
  const searchParams = useSearchParams();

  const selectedFarmUuid = searchParams.get('farm');

  const { data: selectedFarm, isLoading } = useQuery({
    ...getSolarFarmByUuidQuery(selectedFarmUuid ?? ''),
    select: data => data.solar_farm,
    enabled: typeof selectedFarmUuid === 'string',
  });

  // if the UUID in the URL doesn't match a valid farm, remove the UUID from the URL
  useEffect(() => {
    if (!isLoading && selectedFarmUuid && !selectedFarm) {
      searchParams.delete('farm');
      history.push({ search: searchParams.toString() });
    }
  }, [history, isLoading, searchParams, selectedFarm, selectedFarmUuid]);

  return (
    <Stack gutter="lg" style={{ width: '90%', margin: '4rem auto' }}>
      <Row justify="space-between">
        <SolarFarmTypeahead
          selectedFarm={selectedFarm}
          isLoadingSelectedFarm={isLoading}
        />
        {/* add org button will go here eventually */}
        <div />
      </Row>
      {selectedFarm ? (
        <>
          <Stack gutter="xxs">
            <Text variant="h3">{selectedFarm.name}</Text>
            <Text variant="paragraph_small_italic">{selectedFarm.id}</Text>
            <Text variant="paragraph_medium">{selectedFarm.address}</Text>
          </Stack>
          {/* Table goes here */}
        </>
      ) : null}
    </Stack>
  );
};
